import storage from './storage';
import jwtDecode from 'jwt-decode'

export default {

  persistNameToStorage(name) {
    storage.set('cf-name', name);
  },

  getAuthenticationUserFromUrl(docurl) {
    var url = docurl;

    var indexOfToken = url.indexOf('#id_token=', 0);
    if (indexOfToken > 0) {
      var token = url.substring(indexOfToken + 10);
      var authToken = jwtDecode(token);
      // Confirm token was found, and email is present
      if (authToken && authToken.sub) {
        // If running locally, then allow the token regardless of expiry date.
        // This is being done to facilitate automated testing.
        /* if (url.indexOf("localhost:") !== -1) {
          return authToken;
        } */

        // Confirm the auth token's expiry date (exp) is later than current datetime
        if (new Date((authToken.exp - 3592) * 1000) > new Date()) {
          return authToken;
        }
      }
    }

    // Token and/or email were not found, or expiry date (exp) was not later than current datetime... return null
    return null;
  },

  persistUserRoleToStorage(userRole) {
    storage.set('cf-userRole', userRole);
  },

  getAuthenticationUserFromStorage() {
    return storage.get('cf-user');
  }
}



// WEBPACK FOOTER //
// ./src/helpers/app.js